/**
 *  @description :: PDF for GPU page within back admin panel
 *  @author :: Wong Shao Le
 */
'use client'
import React, { useState, useEffect, useRef } from "react";
import {Text, Group, Button, Card, Stack } from "@mantine/core";
import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import { Dropzone } from "@mantine/dropzone";
import { IconFileTypePdf } from "@tabler/icons-react";
import classes from "../PdfGpuPage/PdfGpu.module.css";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import Header from "../static/Header";

export function PdfGpu() {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);
  const pdfDropzoneRef = useRef<() => void>(null);

  const [currentPDF, setNewPDF] = useState<{
      file?: File;
      previewUrl: string;
    }>({
      previewUrl: "",
    });


  const handlePdfUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setNewPDF({ file, previewUrl: url });
    }
  };

  const handleAddPdf = async () => {
    
    if (!currentPDF.file) return;

    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append("pdf", currentPDF.file);

      const response = await axiosPrivate.post("/api/admin/pdf-gpu/create", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      showSuccessAlert("PDF Successfully Uploaded");
      console.log("[INFO] PDF Created with response:", response)

    } catch (error: any) {
      showErrorAlert("Something Went Wrong");
      console.error(error);

    } finally {
      setIsLoading(false);
    }
  };
  


  useEffect(() => {
    const fetchPDF = async () => {
      try {
        setIsLoading(true);
        const response = await axiosPrivate.get("/api/pdf-gpu/get"); 
        const latestPDF = response.data.result;
        if (latestPDF?.pdfSrc) {
          setNewPDF({ previewUrl: latestPDF.pdfSrc });
        }

      } catch (err) {
        console.error("Failed to fetch contact [ERROR]:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPDF();
  }, [axiosPrivate]);

  return (
    <div className={classes.pdfGpuPageContainer}>
      <Header title="PDF for Graphic Card" />
      <Card shadow="sm" radius="md">
        <Stack>
          <Text size="sm" c="dimmed">
            Configure your PDF download source for GPU installation.
          </Text>
            <Text className={classes.Text}>
              Graphic Card Installation Guide <span className={classes.format}>(.pdf)</span>
          </Text>
          <div className={classes.pdfContainer}>
            {currentPDF.previewUrl ? (
              <iframe
                title="PDF Viewer"
                src={currentPDF.previewUrl}
              />
            ) : (
              <IconFileTypePdf size={80} color="black" />
            )}
          </div>
          <Group mt="md" className={classes.buttonGroup}>
            <Dropzone
              openRef={pdfDropzoneRef}
              onDrop={handlePdfUpload}
              accept={["application/pdf"]}
              style={{ display: "none" }}
            />
            <Button
              onClick={() => pdfDropzoneRef.current?.()}
              className={classes.buttonUpload}
              >
              <IconFileTypePdf />
              Upload PDF
            </Button>

            <Button type="button" onClick={handleAddPdf} className={classes.buttonSaveChanges} loading={isLoading}>
              Save Changes
            </Button>
          </Group>
        </Stack>
      </Card>
    </div>
  );
}

export default PdfGpu;
